import { render, staticRenderFns } from "./wzvz_manual.vue?vue&type=template&id=52843e67&scoped=true"
import script from "./wzvz_manual.vue?vue&type=script&lang=js"
export * from "./wzvz_manual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52843e67",
  null
  
)

export default component.exports